import { Text, View } from '@react-pdf/renderer';
import { Nullish } from '@snap-types/types/nullish';

import { styles } from '../styles';

type QuoteLineDetailsProps = {
  drawingId: Nullish<string>;
  drawingRevision: Nullish<string>;
  /**
   * Resolved by `getLeadTimeDisplay`; null when the per-price column carries
   * the lead times instead.
   */
  leadTimeText: string | null;
  showDrawing: boolean;
};

export function QuoteLineDetails({
  drawingId,
  drawingRevision,
  leadTimeText,
  showDrawing,
}: QuoteLineDetailsProps) {
  return (
    <View style={{ minWidth: '110pt' }}>
      {showDrawing && drawingId ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>DWG ID</Text>
          <Text>{drawingId}</Text>
        </View>
      ) : null}

      {showDrawing && drawingRevision ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>Revision No</Text>
          <Text>{drawingRevision}</Text>
        </View>
      ) : null}

      {leadTimeText ? (
        <View style={[styles.gap10, styles.row, styles.justifyBetween]}>
          <Text>Lead Time</Text>
          <Text>{leadTimeText}</Text>
        </View>
      ) : null}
    </View>
  );
}
